module.exports = __webpack_public_path__ + "static/img/apple.8a518130.png";